<template>
  <div class="SectionContactsRtb">
    <div class="body">
      <h3>{{ $t('title') }}</h3>
      <div class="contact">
        <div class="contact-detail">
          <Icon name="phone" />
          <Phone :number="$t('contacts.phone')" @click="fireFbContactEvent" />
        </div>
        <div class="contact-detail">
          <Icon name="envelope" />
          <Email :address="$t('contacts.email')" @click="fireFbContactEvent" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getters } from './../../../utils'

export default {
  computed: getters('screenSizes'),
  methods: {
    fireFbContactEvent() {
      this.$analytics.fbq.event('Contact')
    },
  },
}
</script>

<style lang="scss">
.SectionContactsRtb {
  background-color: $grey-lighter;
  margin: 2rem 0;
  .body {
    padding: 2rem 0;
    .text {
      margin: 1rem 0;
    }

    .contact {
      margin-top: 2rem;

      .contact-detail {
        align-items: center;
        display: flex;
        font-size: $h4;
        line-height: 1.5;

        &.uncentered {
          align-items: normal;
        }
        .Icon {
          // align-items: center;
          color: $main;
          display: flex;
          font-size: 2rem;
          margin-right: 1rem;
        }
      }

      .office-column {
        line-height: 1.5;
        margin-top: 1rem;
        @include md {
          margin-top: 0;
        }
        .office-label {
          font-size: 1.4rem;
          font-weight: $bold;
        }
        .office-address {
          font-size: 1.2rem;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "pl": {
    "title": "Napisz lub zadzwoń",
    "contacts": {
      "email": "info@suninvestmentgroup.com",
      "phone": "+48 734 218 786"
    }
  }
}
</i18n>
